/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetAllLocationStatusLookup = require('../services/GetAllLocationStatusLookup');
var GetAllLocationOfficeTypeLookup = require('../services/GetAllLocationOfficeTypeLookup');
var GetAllLocationActivityLookup = require('../services/GetAllLocationActivityLookup');
var GetAllLocationTypes = require('../services/GetAllLocationTypes');

var DepAddLocationView = require('../views/DepLocationNewView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.4);

  $.when(GetEntityIdentifiers(entityId), GetAllLocationStatusLookup(), GetAllLocationActivityLookup())
    .done(function(entityIdentifiers, locationStatus, locationActivityType) {
      NProgress.set(0.7);
      $.when(
        GetAllLocationOfficeTypeLookup(entityIdentifiers.categoryId),
        GetAllLocationTypes(entityIdentifiers.categoryId)
      )
        .done(function(locationOfficeType, locationType) {
          NavUtils.navigate('dep/entity/' + entityId + '/new-location');
          Scaffold.content.show(
            new DepAddLocationView({
              viewMode: 'int',
              model: new Backbone.Model({
                entityId: entityId,
                entityIdentifiers: entityIdentifiers,
                locationStatus: locationStatus,
                locationOfficeType: locationOfficeType,
                locationType: locationType,
                locationActivityType: locationActivityType
              })
            })
          );
          NProgress.done();
        })
        .fail(function(err) {
          NProgress.done();
        });
    })
    .fail(function(err) {
      NProgress.done();
    });
};
